export const plans = {
  title: "Wählen Sie Ihren Tarif",
  subtitle: "Preis pro Einheit und Monat, mit Mengenrabatten. Sie können mehrere Unterkunftsarten in einer Bestellung kombinieren.",
  typeLabel: "Unterkunftsart",
  types: {
    apartamento: "Apartments",
    hotel: "Hotel",
    camping: "Campingplatz",
    villa: "Villen",
  },
  units: {
    apartamento: "Apartment | Apartments",
    hotel: "Zimmer | Zimmer",
    camping: "Stellplatz | Stellplätze",
    villa: "Villa | Villen",
  },
  decrease: "Eine Einheit entfernen",
  increase: "Eine Einheit hinzufügen",
  billing: {
    label: "Abrechnung",
    monthly: "Monatlich",
    annual: "Jährlich",
    annualSave: "−20 %",
  },
  perUnit: "/Monat pro Einheit",
  totalLine: "{qty} {units} · {total}/Monat insgesamt",
  billedAnnually: "jährliche Abrechnung",
  add: "Zur Bestellung hinzufügen",
  isNew: "Neu",
  pro: {
    badge: "Am beliebtesten",
    tagline: "Die ganze Plattform: KI, Kanäle, Zahlungen und Umsatz.",
    f1: "Online-Check-in und automatische Gästemeldungen an die Behörden",
    f2: "KI-Rezeption rund um die Uhr auf WhatsApp: antwortet, klärt Fragen und automatisiert",
    f3: "Gemeinsamer Posteingang (WhatsApp + Booking, Airbnb und Expedia), Übersetzung und Übergabe an einen Menschen",
    f4: "Elektronische Rechnungsstellung mit VeriFactu",
    f5: "Channel Manager mit über 100 OTAs, gemeinsamer Kalender und Tarifverwaltung (kein Overbooking)",
    f6: "Provisionsfreie Direktbuchungen über Ihre eigene Website",
    f7: "Smarte Schlösser mit automatischen Zugangscodes",
    f8: "Zusatzleistungen und Upselling, Aufenthaltsverlängerungen und Angebote",
    f9: "Zahlungen und Gebühren mit Kautionen",
    f10: "Reinigung und Team, mit Rollen und Berechtigungen",
    f11: "Mehrere Unterkünfte, Analysen und Berichte pro Eigentümer",
  },
  suite: {
    badge: "Alles inklusive",
    tagline: "Der umfassendste Tarif: KI-Telefonempfang, eigene Website und dynamische Preise.",
    lead: "Alles aus Pro, und zusätzlich:",
    s1: "Eigene Rufnummer für WhatsApp und Anrufe",
    s2: "KI-Telefonempfang: geht rund um die Uhr in der Sprache des Gastes ans Telefon",
    s3: "Eingehende Anrufe: 40 Min./Monat inklusive",
    s4: "WebBuilder: Ihre komplette Website",
    s5: "Dynamische Preise: automatische Tarifanpassung",
    s6: "Mehrere Rechnungssteller, die Sie jeder Unterkunft zuordnen können",
  },
  cart: {
    title: "Ihre Bestellung",
    empty: "Wählen Sie Unterkunftsart und Einheiten und fügen Sie dann einen Tarif hinzu.",
    plan: "Tarif {plan}",
    remove: "Entfernen",
    monthlyTotal: "Gesamt pro Monat",
    annualTotal: "Jährliche Abrechnung: {total}",
    planSwitched: "Eine Bestellung enthält nur einen Tarif: Alles ist jetzt {plan}.",
    welcomeTitle: "Einladungsrabatt angewendet",
    welcomeMonthly: "{percent} % Rabatt in den ersten {months} Monaten: {total}/Monat",
    welcomeAnnual: "Sie sparen {amount} bei Ihrer ersten Jahresrechnung",
    pay: "Weiter zur Zahlung",
    paying: "Zahlung wird geöffnet…",
    taxes: "Preise ohne Steuern. Stripe fragt Ihre Rechnungsdaten ab.",
    error: "Die Zahlung konnte nicht geöffnet werden. Bitte versuchen Sie es erneut.",
  },
  payment: {
    success: "Zahlung eingegangen. Ihr Tarif ist in wenigen Sekunden aktiv.",
    failed: "Die Zahlung wurde nicht abgeschlossen. Sie können es jederzeit erneut versuchen.",
    active: "Fertig! Ihr Tarif ist aktiv.",
  },
  active: {
    includes: "Das ist in Ihrem Tarif enthalten",
    discount: "Einladungsrabatt: {percent} % bis {date}",
    discountAnnual: "Einladungsrabatt auf Ihre erste Rechnung angewendet",
    referralCredit: "Sie haben {amount} Guthaben für die Einladung anderer Gastgeber: Es wird von Ihrer nächsten Rechnung abgezogen.",
  },
};
